










import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SelectionFieldText extends Vue {
  @Prop({ type: String, default: '' }) itemText!: string;
  @Prop({ type: String, default: '' }) subText!: string;
}
